<div class="body-restablecer" [class.vista-movil]="esResolucionMovil">
  <h1>Iniciar sesión</h1>

  <div class="form">
    <div class="form-restablecer">
      <div class="form-restablecer-top">
        <span class="titulo-acceso">Verificación en dos pasos</span>
        <span class="subtitulo-acceso">Hemos enviado un código de seguridad a tu correo electrónico. Introdúcelo a continuación para completar el acceso.</span>
      </div>

      <div [formGroup]="envioFactorForm" class="restablecer-form">
        <div class="inputs">
          <!-- <dx-text-box
            label="Correo electrónico*"
            [stylingMode]="stylingMode"
            [labelMode]="labelMode"
            formControlName="correo"
            [elementAttr]="{ tabindex: '1' }"
            [validationStatus]="
              getValidacionEstado('correo', envioFactorForm)
            "
            [validationError]="
              envioFactorForm.get('correo')?.errors ?? {}
                | validationErrorMessage
            "
            (keydown)="focusService.onKeyDown($event)"
            [disabled]="envioCodigoMail"
          ></dx-text-box> -->
          <dx-text-box
            label="Código*"
            [stylingMode]="stylingMode"
            [labelMode]="labelMode"
            formControlName="codigo"
            [elementAttr]="{ tabindex: '1' }"
            [validationStatus]="
              getValidacionEstado('codigo', envioFactorForm)
            "
            [validationError]="
              envioFactorForm.get('codigo')?.errors ?? {}
                | validationErrorMessage
            "
            (keydown)="focusService.onKeyDown($event)"
          >
          </dx-text-box>
        </div>

        <!-- <div class="restablecer" *ngIf="envioCodigoMail">
          <dx-check-box
            text="Mantener la sesión iniciada"
            formControlName ="mantenerSesion"
          >
          </dx-check-box>
        </div> -->

        <div class="form-restablecer-botonera">
          <button class="enviar" 
            (click)="onSubmit()"
          >
            Acceder
          </button>

          <div class="cont-atras">
            <button class="btn-volver-atras" (click)="onVolverAtras()">
              Volver
            </button>
            <button class="btn-volver-enviar" (click)="reenviarCodigo()">
              Reenviar código
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
